import * as actionTypes from "./actionTypes";

export const receivedJackpotListDetails = (id, data) => ({
  type: actionTypes.jackpotList.RECEIVED_DETAILS,
  id,
  data
});